// extracted by mini-css-extract-plugin
module.exports = {"ocean-pro-home-solar-battery":"OceanProHomeSolarBattery_ocean-pro-home-solar-battery__kgCHp","FAQ":"OceanProHomeSolarBattery_FAQ__pr_yh"};